import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as CloudActions from './../actions/cloud.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { CpvService } from '../../../services/cpv.service';
import { CloudService } from '../../services/cloud.service';

@Injectable()
export class CloudEffects {
  @Effect()
  productPrice$: Observable<Action> = this.actions$.pipe(
    ofType(CloudActions.GET_CLOUD_PRODUCT_PRICE),
    mergeMap((action: CloudActions.GetCloudProductPrice) =>
      this.cpvService.getProductPrice(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new CloudActions.GetCloudProductPriceSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new CloudActions.GetCloudProductPriceFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  @Effect()
  accounStatus$: Observable<Action> = this.actions$.pipe(
    ofType(CloudActions.GET_CLOUD_ACTIVATION_STATUS),
    mergeMap((action: CloudActions.GetCloudActivationStatus) =>
      this.cloudService.getAccountStatus(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new CloudActions.GetCloudActivationStatusSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) => {
          if (error.status === 304) {
            return of(new CloudActions.GetCloudActivationStatusNoChange());
          }
          return of(
            new CloudActions.GetCloudActivationStatusFailed(
              error.errorData as TechnicalError,
            ),
          );
        }),
      ),
    ),
  );

  @Effect()
  accountActivation$: Observable<Action> = this.actions$.pipe(
    ofType(CloudActions.ACTIVATE_CLOUD_ACCOUNT),
    mergeMap((action: CloudActions.ActivateCloudAccount) =>
      this.cloudService.activateAccount(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new CloudActions.ActivateCloudAccountSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new CloudActions.ActivateCloudAccountFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private cpvService: CpvService,
    private cloudService: CloudService,
  ) {}
}
